<template>
  <div>
    <!-- 面包屑导航 -->
    <el-breadcrumb separator-class="el-icon-arrow-right">
      <el-breadcrumb-item :to="{ path: '/' }">首页</el-breadcrumb-item>
      <el-breadcrumb-item :to="{ path: '/setting/setting' }">系统设置</el-breadcrumb-item>
      <el-breadcrumb-item>{{WZCDName}}设置</el-breadcrumb-item>
      <el-link type="primary" style="float:right" @click="tosetting()"><i class="el-icon-back"></i> 返回</el-link>
    </el-breadcrumb>
    <!-- 搜索筛选 -->
    <el-form :inline="true" :model="formInline" class="user-search ">
      <!-- <el-form-item label="搜索：">
        <el-input size="small" v-model="selectName" placeholder="输入部门名称"></el-input>
      </el-form-item>
      <el-form-item label="">
        <el-input size="small" v-model="formInline.deptNo" placeholder="输入部门代码"></el-input>
      </el-form-item>
      <el-form-item>
        <el-button size="small" type="primary" icon="el-icon-search" @click="search">搜索</el-button> -->
        <el-button size="mini" type="primary" style="float:right" icon="el-icon-plus" @click="handleEdit()">添加</el-button>

    </el-form>
      <div style="height:65vh;overflow:auto;width:100%">
    <!--列表-->
    <el-table  :data="tableData" size="small" highlight-current-row v-loading="loading"   element-loading-text="拼命加载中" style="width: 100%;margin-top:10px">

        <el-table-column  prop="SiteName" :label="WZCDName+'名称'">
            
        </el-table-column>
       
        <el-table-column  prop="addTime" label="创建时间" align="center" >
        
        </el-table-column>

      <el-table-column align="center" label="操作" width="200" >
        <template slot-scope="scope">
       
          <el-button size="mini" type="info" @click="deleteUser(scope.row)">删除</el-button>
        </template>
      </el-table-column>
    </el-table>
    <!-- 分页组件 -->
    <Pagination v-bind:child-msg="pageparm" @callFather="callFather"></Pagination>
      </div>
    <!-- 编辑界面 -->
    <el-drawer :wrapperClosable= false :title="title" :visible.sync="editFormVisible" :direction="direction" size="30%">
    <!-- <el-dialog :title="title" :visible.sync="editFormVisible" width="40%" @click="closeDialog"> -->
      <el-form label-width="120px" :model="editForm" :rules="rules" ref="editForm">
         <el-form-item :label="WZCDName+'名称:'" prop="SiteName">
          <el-input size="small" v-model="editForm.SiteName" auto-complete="off" placeholder="请输入名称"  style="width: 215px"></el-input>
        </el-form-item>
     
      </el-form>
 
        <div class="demo-drawer__footer flex-r-x"  style="width:30%">
          <el-button size="small" @click="closeDialog">取消</el-button>
          <el-button
          style="margin-right:20px"
            size="small"
            type="primary"
      
        
            @click="submitForm('editForm')"
            >保存</el-button
          >
        </div>
    </el-drawer>


    <!-- <el-drawer :wrapperClosable= false title="权限配置" :visible.sync="quanxian" :direction="direction" size="30%">
        <el-tree
                    :data="typeList"
                    :props="props"
                    show-checkbox
                    ref="tree"
                    default-expand-all
                    :check-strictly="true"
                    node-key="LType">
                </el-tree>
      
        <div class="demo-drawer__footer flex-r-x"  style="width:30%">
          <el-button size="small" @click="closeDialog">取消</el-button>
          <el-button
          style="margin-right:20px"
            size="small"
            type="primary"
     
            @click="baocun"
            >保存</el-button
          >
        </div>
    </el-drawer> -->
    <!-- </el-dialog> -->
      <el-dialog title="修改密码" :visible.sync="passShow" width="40%" >
      <el-form label-width="120px" :model="editForm">

        <el-form-item label="密码" prop="deptNo">
          <el-input size="small" placeholder="请输入密码" v-model="Pwd" show-password auto-complete="off"></el-input>
        </el-form-item>
      
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button size="small" @click="closeDialog">取消</el-button>
        <el-button size="small" type="primary" :loading="loading" @click="topass()">保存</el-button>
      </div>
    </el-dialog>
      <el-dialog title="充值" :visible.sync="chongShow" width="40%" >
      <el-form label-width="120px">
        <el-form-item label="充值金额" prop="money">
          <el-input size="small" placeholder="请输入充值金额" v-model="money"  auto-complete="off"></el-input>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button size="small" @click="closeDialog">取消</el-button>
        <el-button size="small" type="primary" :loading="loading"  @click="ADDmoney()">充值</el-button>
      </div>
    </el-dialog>

  </div>
</template>

<script>
import { deptList, deptSave, deptDelete } from '../../api/userMG'
import CropperImage from "../../components/CropperImage";
import {getListManageLogin,addManageLogin,delManageLogin,editManageLogin,editManageLoginmoney,editManageLoginPwd,editManageLoginIsdisable} from "@/api/getData";
import Pagination from '../../components/Pagination'
export default {
  data() {
    return {
      DianList:[],
        quanxian:false,
      formValidate: {
        mainImage: "",
      },
      props: {
          children: 'listsub',
          label: 'Name'
        },
       direction: "ltr",
      passShow:false,
      money:'',
      input:'',
      nshow: true, //switch开启
      fshow: false, //switch关闭
      loading: false, //是显示加载
      editFormVisible: false, //控制编辑页面显示与隐藏
      chongShow:false,
      title: '添加',
      tableData:[],
      typeList:[],
      Pwd:'',
      RoleID:'',
      SelectStoresID:this.$route.params.id,
      WZCDName:localStorage.getItem('WZCDName'),
      editForm: {
          SiteName:''
        // preferentialType:0,
        // LevelName:'',
        // preferentialvalue:'',
      },
      // rules表单验证

      rules: {
        SiteName: [{ required: true, message: '请输入名称', trigger: 'blur' }],
        //   Phone: [{ required: true, message: '请输入联系电话', trigger: 'blur' }],
        //   Name: [{ required: true, message: '请输入联系人', trigger: 'blur' }],
        //   pwd: [{ required: true, message: '请输入密码', trigger: 'blur' }],
        //   money: [{ required: true, message: '请输入余额', trigger: 'blur' }],
        //   ShopName: [{ required: true, message: '请输入商户名称', trigger: 'blur' }],
      },
      formInline: {
        page: 1,
        limit: 10,
        varLable: '',
        varName: '',
        token: localStorage.getItem('logintoken')
      },
      // 删除部门
      seletedata: {
        ids: '',
        token: localStorage.getItem('logintoken')
      },
      userparm: [], //搜索权限
      listData: [], //用户数据
      // 分页参数
      pageparm: {
        currentPage: 1,
        pageSize: 10,
        total: 10
      }
    }
  },
  // 注册组件
  components: {
    Pagination,
     CropperImage,
  },
  /**
   * 数据发生改变
   */

  /**
   * 创建完毕
   */
  created() {
    //    this.getType()
    this.getList()
    this.getDianList()
    //   this.getList()
  },

  /**
   * 里面的方法只有被调用才会执行
   */
  methods: {
      tosetting(){
         this.$router.go(-1)
      },
        getDianList(){
       var data = { 
         SelectStoresID:localStorage.getItem("StoresID"),
          token: localStorage.getItem("token"),
          StoresID:localStorage.getItem("StoresID")
      }
        var that = this
       this.ajax('getListStores.aspx',JSON.stringify(data),"POST",function(res){

           if (res.orsuccess == "1") {
               that.DianList =res.data
               
            }

      })
},

  changedian(){
      this.pageparm ={
        currentPage: 1,
        pageSize: 10,
        total: 0,
      },
    
      this.getList()
    },
        deleteUser(row){
        this.$confirm("确定要删除吗?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
         var data = { SelectStoresID:this.SelectStoresID,
          StoresID:localStorage.getItem("StoresID"),
          token: localStorage.getItem("token"),
             SiteID:row.ID,
        
        }
        var that = this
        this.ajax('delSite.aspx',JSON.stringify(data),"POST",function(res){

           if (res.orsuccess == "1") {
              that.$message({
                type: "success",
                message: "删除成功",duration:2000,
              });
        
              that.getList()
              //  that.provinceList = res.data
            }

        })
        })
        .catch(() => {
            ;
        });
   
    },


    handlePassword(){
        this.quanxian = true
    },
    handleEdit(row){
          if (row != undefined && row != 'undefined') {
              this.title = '编辑'
       
              this.editForm = row
           
    
          } else {
              this.title = '添加'
                this.editForm = {
                 SiteName:''
                }
          }
          this.editFormVisible = true
    },
    handleCheckChange(data, checked, indeterminate) {
        console.log(data, checked, indeterminate);
         console.log(this.$refs.tree.getCheckedNodes());
      },

    getList(){

    //  this.tableLoading = true
       var data = { 
        SelectStoresID:this.SelectStoresID,
          token: localStorage.getItem("token"),
          StoresID:localStorage.getItem("StoresID"),
          pages:this.formInline.page,
          psize:this.formInline.limit,

      }
       const loading = this.$loading({
          lock: true,
          text: '加载中...',
          spinner: 'el-icon-loading',
          background: 'rgba(0, 0, 0, 0.7)'
        });
      
        var that = this
      this.ajax('getListSite.aspx',JSON.stringify(data),"POST",function(res){
          if (res.orsuccess == "1") {
                that.tableLoading = false
                that.tableData = res.data
                  that.pageparm.total = res.allcount

                 loading.close();
          } 

      })
  
    },

    // 获取公司列表

    // 分页插件事件
    callFather(parm) {
      this.formInline.page = parm.currentPage
      this.formInline.limit = parm.pageSize
      this.getList()
    },
    // 搜索事件
    search() {
      this.getdata(this.formInline)
    },
    //显示编辑界面

    // 编辑、增加页面保存方法
    submitForm(editData) {

      this.$refs[editData].validate(valid => {
        if (valid) {
            var data = this.editForm
                data.token=localStorage.getItem("token")
                data.StoresID=localStorage.getItem("StoresID")
                data.SelectStoresID  = this.SelectStoresID
                var that = this
            if(this.title == '添加'){
                this.ajax('addSite.aspx',JSON.stringify(data),"POST",function(res){
                    if (res.orsuccess == "1") {
                        that.$message({
                            type: "success",
                            message: "新建成功",duration:2000,
                        });
                        that.editFormVisible = false
                        that.getList()
                     }

                })

            }else {
                data.SiteID =  this.editForm.ID
                 this.ajax('editSite.aspx',JSON.stringify(data),"POST",function(res){
                    if (res.orsuccess == "1") {
                        that.$message({
                            type: "success",
                            message: "修改成功",duration:2000,
                        });
                        that.editFormVisible = false
                        that.getList()
                     }

                })
            }
        } else {
          return false
        }
      })
    },

    // 关闭编辑、增加弹出框
    closeDialog() {
      this.passShow = false,
      this.chongShow = false,
      this.editFormVisible = false
    }
  }
}
</script>

<style scoped>
.user-search {
  margin-top: 20px;
}
.userRole {
  width: 100%;
}
</style>



// WEBPACK FOOTER //
// src/views/arrange/site.vue